import { useState, useContext } from 'react';
import styled from 'styled-components';
import { CredusText, CredusDropDown } from 'ui';
import { HiOutlineDotsHorizontal } from 'react-icons/hi';

import { CandidateCategory } from '../../../../../contexts/CandidateContext';
import { CandidateContext } from '../../../../../contexts/CandidateContext';

export interface ExamCategoryTableProps {
  candidateData: Array<CandidateCategory>;
  setShowCandidateData: React.Dispatch<React.SetStateAction<boolean>>;
}

const ExamCategoryTable = ({
  candidateData,
  setShowCandidateData,
}: ExamCategoryTableProps) => {
  const [active, setActive] = useState(0);
  const [showDropDown, setShowDropDown] = useState(false);
  const { setCandidateCategory } = useContext(CandidateContext);

  const handleDropDown = (index: number) => {
    setShowDropDown((prev) => !prev);
    setActive(index);
  };

  const handleView = (candidate: CandidateCategory) => {
    setCandidateCategory(candidate);
    setShowCandidateData(true);
  };
  return (
    <Table>
      <tbody>
        <tr>
          {/* <Th>
          <Checkbox />
        </Th> */}
          <Th>
            <CredusText size="md">Exam category</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Period</CredusText>
          </Th>

          <Th>
            <CredusText size="md">Created by</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Candidates</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Action</CredusText>
          </Th>
        </tr>

        {candidateData?.map((candidate: CandidateCategory, index: number) => {
          const { category, period, candidateCount } = candidate;
          return (
            <tr key={index}>
              {/* <Td>
              <div style={{ textAlign: 'center' }}>
                <Checkbox />
              </div>
            </Td> */}
              <Td>
                <CredusText size="sm">{category}</CredusText>
              </Td>
              <Td>
                <CredusText size="sm">{period}</CredusText>
              </Td>

              <Td>
                <CredusText size="sm">{''}</CredusText>
              </Td>
              <Td>
                <CredusText size="sm">{candidateCount}</CredusText>
              </Td>
              <Td>
                <Div>
                  <HiOutlineDotsHorizontal
                    color="#ABABAB"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDropDown(index)}
                  />
                  {showDropDown && index == active && (
                    <CredusDropDown
                      items={[
                        <CredusText
                          size="xs"
                          onClick={() => handleView(candidate)}
                        >
                          View
                        </CredusText>,
                        <CredusText size="xs">Send Invite</CredusText>,
                        <CredusText size="xs">Delete</CredusText>,
                      ]}
                      width={'100px'}
                    />
                  )}
                </Div>
              </Td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default ExamCategoryTable;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  background: #ffeae7;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;
const Td = styled.td`
  /* background: #fbfbfb; */
  padding: 1rem 1.2rem;
  min-width: 44px;
`;

const Div = styled.div`
  position: relative;
`;
